import { authenticated } from './WebRequest';
import type { ApiThunk } from './types/Order';

export type FormulaSupportFormula = {
  baseid: number | null;
  basecode: string;
  basevolume: number;
  cnts: { cntcode: string; volume: number }[];
};

export type FormulaSupportMessage = {
  formulasupportmessageid: number;
  supportcaseid: number;
  sender: 'POS' | 'LAB';
  zoneid: number;
  productid: number | null;
  productname: string | null;
  cansizecode: string | null;
  colourcode: string | null;
  colourname: string | null;
  colourcard: string | null;
  rgb: number | null;
  orderid: number | null;
  formula: FormulaSupportFormula | null;
  notes: string | null;
  created_at: string;
  seen_at: string | null;
  username: string;
};

export type FormulaSupportCase = {
  supportcaseid: number;
  siteid: number;
  category: 'formula_feedback' | 'formula_request';
  status: string;
  priority: string;
  created_at: string;
  status_changed_at: string;
  seen_at: string | null;
  messages: FormulaSupportMessage[];
  latest_message: FormulaSupportMessage | null;
};

export type FormulaSupportCasePage = {
  cases: FormulaSupportCase[];
  total: number;
  page: number;
  page_size: number;
  has_next: boolean;
};

export type FormulaSupportListParams = {
  search?: string;
  archived?: boolean;
  page?: number;
  page_size?: number;
  sort?: 'asc' | 'desc';
};

export type FormulaSupportPayload = Partial<
  Pick<
    FormulaSupportMessage,
    | 'productid'
    | 'productname'
    | 'cansizecode'
    | 'colourcode'
    | 'colourname'
    | 'colourcard'
    | 'rgb'
    | 'orderid'
    | 'notes'
  >
> & {
  zoneid: number;
  formula?: FormulaSupportFormula | null;
  priority?: string;
  username?: string | null;
};

export function create_formula_feedback(
  siteid: number,
  payload: FormulaSupportPayload
): ApiThunk<FormulaSupportCase> {
  return authenticated.post<FormulaSupportCase>(
    `/formula_support/site/${siteid}/feedback`,
    payload
  );
}

export function get_formula_feedback_for_order(
  siteid: number,
  orderid: number
): ApiThunk<{ case: FormulaSupportCase | null }> {
  return authenticated.get<{ case: FormulaSupportCase | null }>(
    `/formula_support/site/${siteid}/orders/${orderid}/feedback`
  );
}

export function create_formula_request(
  siteid: number,
  payload: FormulaSupportPayload
): ApiThunk<FormulaSupportCase> {
  return authenticated.post<FormulaSupportCase>(
    `/formula_support/site/${siteid}/request`,
    payload
  );
}

export function list_formula_support_cases(
  siteid: number,
  params: FormulaSupportListParams = {}
): ApiThunk<FormulaSupportCasePage> {
  return authenticated.get<FormulaSupportCasePage>(
    `/formula_support/site/${siteid}/cases`,
    { params }
  );
}

export function list_formula_support_notifications(
  siteid: number
): ApiThunk<FormulaSupportCase[]> {
  return authenticated.get<FormulaSupportCase[]>(
    `/formula_support/site/${siteid}/notifications`
  );
}

export function mark_formula_support_case_seen(
  siteid: number,
  caseid: number
): ApiThunk<FormulaSupportCase> {
  return authenticated.post<FormulaSupportCase>(
    `/formula_support/site/${siteid}/cases/${caseid}/seen`
  );
}

export function archive_formula_support_cases(
  siteid: number,
  caseids: number[]
): ApiThunk<FormulaSupportCase[]> {
  return authenticated.post(`/formula_support/site/${siteid}/cases/archive`, {
    caseids,
  });
}
